import * as React from "react";
import axios from "axios";
import { Outlet, Link } from "react-router-dom";
import {
  LockClosedIcon,
  EyeIcon,
  EyeSlashIcon,
} from "@heroicons/react/20/solid";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Image } from "primereact/image";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Controller, useForm } from "react-hook-form";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

const schema = yup
  .object({
    username: yup
      .string()
      .trim()
      .matches(/^[a-z]+$/, "Is not in correct format")
      .required(),
    password: yup.string().required(),
  })
  .required();

export default function Login(props) {
  const [remember, setRemember] = React.useState(
    localStorage.getItem("remember_me")
  );

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    if (data.remember_me) {
      localStorage.setItem(
        "remember_me",
        JSON.stringify({
          username: data.username,
          password: data.password,
        })
      );
    } else {
      localStorage.removeItem("remember_me");
      setRemember(null);
    }

    axios
      .post(
        `https://gongaji-authentication-service-m3gra3glsq-et.a.run.app/v1/auth-psw/signin`,
        {
          id: data.username,
          password: data.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Version: "V3",
          },
        }
      )
      .then((response) => {
        console.log(response);
        console.log(response.data);

        if (response.data.status) {
          props.setToken(response.data.token);
          props.setAuth(response.data.data);
        } else {
          alert(response.data.message);
        }
      })
      .catch((error) => {
        if (error.response) {
          alert(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          console.log("Request was made but no response received");
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error("Error:", error.message);
        }
      });
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  return (
    <>
      <div
        className="relative flex items-center justify-center overflow-hidden bg-sky-100 py-4"
        style={{ minHeight: "100svh" }}
      >
        <div
          className="fixed -top-32 -left-24 z-0 h-60 w-60 rotate-45 transform rounded-xl bg-sky-600 lg:-top-5 lg:-left-16"
          style={{
            boxShadow: "10px 10px 20px #076698, -10px -10px 10px #ffffff",
          }}
        ></div>
        <div
          className="fixed -bottom-6 -right-10 h-48 w-48 rotate-12 transform rounded-xl bg-sky-600"
          style={{
            boxShadow: "-10px 10px 20px #076698, 10px -10px 10px #ffffff",
          }}
        ></div>
        <img
          className="fixed top-10 right-12 h-32 rotate-12 lg:top-0 lg:right-12"
          src={require("../../assets/syaamil-group-square.png")}
          alt="Syaamil Group"
          style={{ filter: "drop-shadow(3px 3px 2px rgb(232 179 59))" }}
        />
        <img
          className="fixed bottom-10 left-10 h-32 rotate-6 transform md:block lg:bottom-20 lg:left-10"
          src={require("../../assets/syaamil-group-square.png")}
          alt="Syaamil Group"
          style={{ filter: "drop-shadow(4px 4px 3px rgb(232 179 59))" }}
        />
        <div className="z-1 w-10/12 rounded-2xl bg-white py-12 px-10 shadow-2xl sm:w-8/12 md:w-6/12 md:py-12 md:px-12 lg:w-4/12">
          <div className="flex flex-col items-center gap-4">
            <Image
              src={require("../../assets/syaamil-group.png")}
              className="w-28"
              alt="Syaamil Group"
            />
            <h2 className="text-md  my-2 font-semibold tracking-tight text-gray-900 md:text-xl">
              Sign in to your account
            </h2>
            <form
              className="w-full"
              onSubmit={handleSubmit(onSubmit)}
              autoComplete="off"
            >
              <div className="flex flex-col gap-2">
                <Controller
                  name="username"
                  control={control}
                  render={({ field, fieldState }) => (
                    <>
                      <div className="flex flex-col gap-1">
                        <InputText
                          id={field.name}
                          value={field.value}
                          placeholder="Enter Your Username"
                          className={`p-inputtext-sm ${classNames({
                            "p-invalid": fieldState.error,
                          })}`}
                          onChange={(e) => field.onChange(e.target.value)}
                        />
                        {getFormErrorMessage(field.name)}
                      </div>
                    </>
                  )}
                />

                <Controller
                  name="password"
                  control={control}
                  render={({ field, fieldState }) => (
                    <>
                      <div className="flex flex-col gap-1">
                        <Password
                          id={field.name}
                          {...field}
                          inputRef={field.ref}
                          placeholder="Enter Your Password"
                          feedback={false}
                          toggleMask
                          className={`p-inputtext-sm  ${classNames({
                            "p-invalid": fieldState.error,
                          })}`}
                          inputClassName="w-full !pr-8"
                        />
                        {getFormErrorMessage(field.name)}
                      </div>
                    </>
                  )}
                />

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <input
                      id="remember_me"
                      type="checkbox"
                      className="h-3 w-3 rounded border-gray-400 text-indigo-600 focus:ring-indigo-500"
                      {...register("remember_me")}
                      defaultChecked={remember ? true : false}
                    />
                    <label
                      htmlFor="remember_me"
                      className="text-xs text-gray-800"
                    >
                      Remember me
                    </label>
                  </div>

                  <Link
                    to="/forgot-password"
                    className="text-xs font-medium text-indigo-500 hover:text-indigo-700"
                  >
                    Forgot your password?
                  </Link>
                </div>

                <Button
                  type="submit"
                  label="Login"
                  size="sm"
                  icon="pi pi-lock"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
